export enum ErrorCode {
  FieldCannotBeEmpty = 'FieldCannotBeEmpty',
  FieldMustBeGreaterThan = 'FieldMustBeGreaterThan',
  NameNotUnique = 'NameNotUnique',
  EntityNotFound = 'EntityNotFound',
  ValueAlreadyInUse = 'ValueAlreadyInUse',
  InsufficientPrivileges = 'InsufficientPrivileges',
  MissingValue = 'MissingValue',
  Mismatch = 'Mismatch',
}
